<!-- Contact Component -->
<script>
  import { Col, Row, Container, FormGroup, Input, Tooltip } from "sveltestrap";
  import { scrollTo } from "svelte-scrollto";

  export let comments
  let name, phone, phoneInvalid, nameInvalid

  const phoneNumber = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;

  function encode(data) {
    return Object.keys(data)
            .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
            .join("&")
  }

  const sendContact = () => {
    if(name.length == 0){
      nameInvalid = true
      return
    }
    if(!phone.match(phoneNumber)){
      phoneInvalid = true
      return
    }
      fetch("/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: encode({
          "form-name": "contact",
          name,
          phone,
          "subject": "Contractor Work Requested",
          comments,
          "send" : "Send Message"
        })
      }).then(
              () => {
                scrollTo({element: "#home"})
                alert("Thank you we'll contact you as soon as possible!")
                name = ""
                phone = ""
                comments = ""
              }
      ).catch(error => alert(error))
  }
</script>

<!-- CONTACT FORM START-->
<section class="section common-section" id="contact">
  <Container>
    <Row>
      <Col lg={{ size: 8, offset: 2 }}>
        <h1 class="section-title text-center">Get In Touch</h1>
        <div class="section-title-border mt-3" />
        <p class="section-subtitle text-muted text-center font-secondary pt-4">
          We want to hear from you, contact us and tell us your project. We will be in site in no time to evaluate and start the job.
        </p>
      </Col>
    </Row>
    <Row>
      <Col lg="4">
        <div class="mt-4 pt-4">
          <p class="mt-4">
            <span class="h5">Working Hours:</span><br />
            <span class="text-muted d-block mt-2">9:00AM To 6:00PM</span>
          </p>
        </div>
      </Col>
      <Col lg="8">
        <div class="custom-form mt-4 pt-4">
          <form on:submit|preventDefault={sendContact} name="contact" data-netlify="true" netlify-honeypot="status">
            <p style="display: none">
              <input name="status" />
            </p>
            <p id="error-msg" />
            <div id="simple-msg" />
            <Row>
              <Col lg="6">
                <FormGroup class="mt-2">
                  <Input
                    name="name"
                    id="name"
                    type="text"
                    class="form-control"
                    placeholder="Your name*"
                    bind:value={name}
                    on:keydown={() => nameInvalid = null}
                    invalid={nameInvalid}
                  />
                </FormGroup>
              </Col>
              <Col lg="6">
                <FormGroup class="mt-2">
                  <Input
                    name="phone"
                    id="phone"
                    type="tel"
                    placeholder="Your phone (format: ###-###-####)*"
                    bind:value={phone}
                    on:keydown={() => phoneInvalid = null}
                    invalid={phoneInvalid}
                  />
                </FormGroup>
              </Col>
            </Row>
            <input type="hidden" />
            <Row>
              <Col lg="12">
                <FormGroup class="mt-2">
                  <Input
                    type="textarea"
                    name="comments"
                    id="comments"
                    rows="4"
                    class="form-control"
                    placeholder="Your message..."
                    bind:value={comments}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col lg="12" class="text-end">
                <Input
                  type="submit"
                  id="submit"
                  name="send"
                  class="submitBnt btn btn-primary"
                  value="Send Message"
                  on:click={sendContact}
                />
              </Col>
            </Row>
          </form>
        </div>
      </Col>
    </Row>
  </Container>
</section>
<!-- CONTACT FORM END-->

<!--START SOCIAL-->
<section class="contact-social bg-light">
  <Container>
    <Row class="align-items-center">
      <Col lg="4">
        <ul class="list-inline social mt-4">
          <li class="list-inline-item">
            <a href={"https://www.facebook.com/estradasconstruction"} class="social-icon"><i class="mdi mdi-facebook" /></a>
          </li>
          <li class="list-inline-item">
            <a href={"https://twitter.com/estradasconstr"} class="social-icon"><i class="mdi mdi-twitter" /></a>
          </li>
          <li class="list-inline-item">
            <a href={"#"} class="social-icon"><i class="mdi mdi-linkedin" /></a>
          </li>
          <li class="list-inline-item">
            <a href={"#"} class="social-icon"
              ><i class="mdi mdi-google-plus" /></a
            >
          </li>
          <li class="list-inline-item">
            <a href={"#"} class="social-icon"><i class="mdi mdi-dribbble" /></a>
          </li>
        </ul>
      </Col>
      <Col lg="4" class="mt-4">
        <p class="contact-title">
          <i class="pe-7s-call" /> &nbsp;(614) 984 4256
        </p>
      </Col>
      <Col lg="4" class="mt-4 text-end">
        <p class="contact-title">
          <i class="pe-7s-mail-open" />&nbsp; jcarmenescogido1983@gmail.com
        </p>
      </Col>
    </Row>
  </Container>
</section>
<!--END SOCIAL-->
